import fetch from 'cross-fetch'; // eslint-disable-line no-unused-vars
import { RSAA } from 'redux-api-middleware';
import { addMeta, tranformSuccessPayload, tranformEmptyPayload, transformBodyParams } from './transformers';
import Routes from 'utils/routes.js.erb';
import { API_FAILURE, authHeaders } from './index';
import { getParamsFromQuery } from 'utils/query';

export const ADMIN_USER_UPDATE_REQUEST = 'ADMIN_USER_UPDATE_REQUEST';
export const ADMIN_USER_UPDATE_RECEIVE = 'ADMIN_USER_UPDATE_RECEIVE';

const patchAdminUser = (bodyParams, meta = {}) => {
  return {
    [RSAA]: {
      endpoint: Routes.api_dashboard_setting_path(0),
      headers: authHeaders(),
      method: 'PATCH',
      types: [addMeta(ADMIN_USER_UPDATE_REQUEST, meta), tranformSuccessPayload(ADMIN_USER_UPDATE_RECEIVE, meta), API_FAILURE],
      body: transformBodyParams(bodyParams),
      fetch: fetch,
    },
  };
}

export const updateAdminUser = (id, params, meta = {}) => {
  return patchAdminUser(id, params, meta);
}

export const ADMIN_USER_RESET_PASSWORD_REQUEST = 'ADMIN_USER_RESET_PASSWORD_REQUEST';
export const ADMIN_USER_RESET_PASSWORD_RECEIVE = 'ADMIN_USER_RESET_PASSWORD_RECEIVE';

const postForgotPassword = (bodyParams, meta = {}) => {
  return {
    [RSAA]: {
      endpoint: Routes.api_dashboard_forgot_password_path(),
      headers: { 'Content-Type': 'application/json' },
      method: 'POST',
      types: [addMeta(ADMIN_USER_RESET_PASSWORD_REQUEST, meta), tranformEmptyPayload(ADMIN_USER_RESET_PASSWORD_RECEIVE, meta), API_FAILURE],
      body: transformBodyParams(bodyParams),
      fetch: fetch,
    },
  };
}

export const forgotPassword = (params, meta = {}) => {
  return postForgotPassword(params, meta);
}

export const ADMIN_USER_CHANGE_PASSWORD_REQUEST = 'ADMIN_USER_CHANGE_PASSWORD_REQUEST';
export const ADMIN_USER_CHANGE_PASSWORD_RECEIVE = 'ADMIN_USER_CHANGE_PASSWORD_RECEIVE';

const postChangePassword = (bodyParams, meta = {}) => {
  return {
    [RSAA]: {
      endpoint: Routes.api_dashboard_change_password_path(),
      headers: { 'Content-Type': 'application/json' },
      method: 'POST',
      types: [addMeta(ADMIN_USER_CHANGE_PASSWORD_REQUEST, meta), tranformEmptyPayload(ADMIN_USER_CHANGE_PASSWORD_RECEIVE, meta), API_FAILURE],
      body: transformBodyParams(bodyParams),
      fetch: fetch,
    },
  };
}

export const changePassword = (search, params, meta = {}) => {
  const query = getParamsFromQuery(search);
  return postChangePassword({ ...params, resetPasswordToken: query.token }, meta);
}
